module.exports = __webpack_public_path__ + "static/media/p16-tickets.283169f8.csv";